module.exports = __webpack_public_path__ + "img/pets.5407cbd6.svg";